<template>
    <div style="width: 800px;margin: 30px auto">
        <div style="margin: 10px auto 30px 50px; height: 20px" id="auxinGene">
            <div style="float: left">
                <a style="font-size: 20px;color:#407338"><b><i>Auxin</i>-related genes in <i>B. rapa</i><br/></b></a>
            </div>
            <div style="float: right; margin-right: 50px">
                <el-button style="width: 240px;font-weight: bold; font-size: 16px" @click="exportExcel">Export result as Excel</el-button>
            </div>
        </div>
        <div style="margin-top: 30px">
            <el-button @click="resetSubfamilyFilter">Clear sub family filter</el-button>
            <el-table
                id="auxinGeneShow"
                ref="filterTable"
                :data="AuxinGene_list"
                height="580px"
                line-hight="10px"
                border
                header-cell-style="color:#407338;text-align:center"
                :row-style="{height:'35px'}"
                cell-style="color:#407338;text-align:center">
                <el-table-column
                    prop="subfamily"
                    label="Sub family"
                    width="180px"
                    column-key="subfamily" :filters=filters
                    :filter-method="filterHandler"
                ></el-table-column>
                <el-table-column prop="agene" label="Br Gene" width="200px">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleBraGene(scope.row)" style="color: #3742fa; background: inherit">{{scope.row.agene}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="bsgene" label="At syntenic ortholog" width="200px">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleAtGene(scope.row)" style="color: #3742fa; background: inherit">{{scope.row.bsgene}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="bnsgene" label="At ortholog" width="200px">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleAtnGene(scope.row)" style="color: #3742fa; background: inherit">{{scope.row.bnsgene}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <FunctionSelection v-if="boxtarget" :target="selection_gene"
                @hideBox="hideSelectionBox"
                @watchSubFunction="common.searchSubFunction"></FunctionSelection>
            <FucntionSelectionBra v-if="Bra_boxtarget" :target="selection_gene"
                @hideBox="hideBraSelectionBox"
                @watchSubFunctionBra="common.searchSubFunction"></FucntionSelectionBra>                   
            <FunctionSelectionAth10 v-if="Ath_boxtarget" :target="selection_gene"
                @hideBox="hideAth10SelectionBox"
                @watchSUbFunctionAth10="common.searchSubFunction"></FunctionSelectionAth10>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import FileSaver from 'file-saver';
    import XLSX from 'xlsx';
    import FunctionSelection from "../components/FunctionSelection";
    import FucntionSelectionBra from "../components/FucntionSelectionBra";
    import FunctionSelectionAth10 from "../components/FunctionSelectionAth10";
    export default {
        name: "AuxinGene",
        data() {
            return {
                AuxinGene_list: {},
                boxtarget: 0,
                Ath_boxtarget: 0,
                Bra_boxtarget: 0,
                selection_gene: '',
                filters: {}
            }
        },
        mounted() {
            this.judgeStyle();
            this.get_AuxinGene_list()
        },
        components: {
            FunctionSelection,
            FucntionSelectionBra,
            FunctionSelectionAth10
        },
        methods: {
            judgeStyle() {
                document.getElementsByTagName('html')[0].style.height = '';
                document.getElementsByTagName('body')[0].style.height = '';
            },
            get_AuxinGene_list() {
                axios({
                    url:'http://39.100.233.196:8001/api/get-auxin-gene/',
                    type:'json',
                    method:'get',
                }).then((res)=>{
                    this.AuxinGene_list = res.data.slice(0, res.data.length-1)
                    this.filters = res.data[res.data.length-1]
                    // console.log(this.filters)
                })
            },
            resetSubfamilyFilter() {
                this.$refs.filterTable.clearFilter('subfamily');
            },
            filterHandler(value, row, column) {
                const property = column['property'];
                return row[property] === value;
            },
            handleAtnGene(row) {
                // console.log(row.bnsgene)
                this.selection_gene = row.bnsgene.split(' ')[0]
                if (this.selection_gene != '-') {
                    this.Ath_boxtarget = 1;
                    this.Bra_boxtarget = 0;
                }
            },
            handleAtGene(row) {
                // console.log(row.bsgene)
                this.selection_gene = row.bsgene.split(' ')[0]
                if (this.selection_gene != '-') {
                    this.Ath_boxtarget = 1;
                    this.Bra_boxtarget = 0;
                }
            },
            handleBraGene(row) {
                // console.log(row.agene.split(' ')[0])
                this.selection_gene = row.agene.split(' ')[0]
                if (this.selection_gene != '-') {
                    this.Bra_boxtarget = 1;
                    this.Ath_boxtarget = 0;
                }
            },
            hideSelectionBox() {
                this.Bra_boxtarget = 0;
            },
            hideAth10SelectionBox () {
                this.Ath_boxtarget = 0;
            },
            searchGeneSeq (geneID) {
                // console.log(geneID)
                let routeUrl = this.$router.resolve({
                    path: "../GeneSequence/",
                    query: {Gene: geneID}
                });
                window.open(routeUrl.href, '_blank');
            },
            exportExcel() {
                var fix = document.querySelector('.el-table__fixed');
                var wb;
                if (fix) {
                    wb = XLSX.utils.table_to_book(document.querySelector("#auxinGeneShow").removeChild(fix))
                    document.querySelector("#auxinGeneShow").appendChild(fix)
                } else {
                    wb = XLSX.utils.table_to_book(document.querySelector("#auxinGeneShow"))
                }
                var wbout = XLSX.write(wb, {
                    bookType: "xlsx",
                    bookSST: true,
                    type: "array"
                });
                try {
                    FileSaver.saveAs(
                        new Blob([wbout], {
                            type: "application/octet-stream"
                        }),
                        "Auxin-related_genes_in_B.rapa.xlsx"
                    )
                } catch (e) {
                    if (typeof console !== 'undefined') console.log(e, wbout);
                }
                return wbout;
            },
        },
    }
</script>

<style>

#auxinGene .el-button {
    background-color: #E1E1E1;
    color: #407338;
    border: #ADADAD;
    font-size: 12px;
}

#auxinGene .el-button:hover {
    background-color: #E5F1FB;
    color: black;
}

</style>